// extracted by mini-css-extract-plugin
module.exports = {"discount":"_4430","content":"_3691","hd":"_5915","title":"_12437","arrow":"_2108","bd":"_10583"};